import { render, staticRenderFns } from "./PointsForRecord.vue?vue&type=template&id=4152c03c"
import script from "./PointsForRecord.vue?vue&type=script&lang=ts&setup=true"
export * from "./PointsForRecord.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PointsForRecord.vue?vue&type=style&index=0&id=4152c03c&prod&lang=stylus"
import style1 from "./PointsForRecord.vue?vue&type=style&index=1&id=4152c03c&prod&module=true&lang=stylus"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports